<template>
    <a :href="link" target="_blank" :class="{'applications': hasApplications, 'other-companies': hasOtherCompanies}">
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.8 26.8H2.9c-1.6 0-2.9-1.3-2.9-2.9V6.1c0-1.6 1.3-2.9 2.9-2.9h21.2c1.6 0 2.9 1.3 2.9 2.9V13c0 .8-.7 1.5-1.5 1.5S24 13.8 24 13V6.2H3v17.5h9.8c.8 0 1.5.7 1.5 1.5s-.7 1.6-1.5 1.6z" />
            <path d="M25.3 10h-24v2h24v-2zM7 5.4c-.6 0-1-.4-1-1V1c0-.6.4-1 1-1s1 .4 1 1v3.4c0 .6-.4 1-1 1zM20 5.4c-.6 0-1-.4-1-1V1c0-.6.4-1 1-1s1 .4 1 1v3.4c0 .6-.4 1-1 1z" />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M24 16c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm-.2 12.9c-.7 0-1.3-.6-1.3-1.3 0-.7.6-1.3 1.3-1.3.7 0 1.3.6 1.3 1.3 0 .7-.6 1.3-1.3 1.3zm1.7-5.3c-.3.3-.6.5-.6.7v.4c0 .3-.2.5-.5.5h-1.1c-.3 0-.5-.2-.5-.5v-.5c0-.8.6-1.3 1.1-1.7.4-.3.7-.6.7-.9
                0-.4-.3-.6-.8-.6s-.8.3-1 .5c-.1.1-.2.1-.2.2-.2.1-.4.1-.6 0l-.7-.7c-.1-.1-.1-.2-.1-.3 0-.1 0-.3.1-.4 0 0 1-1.2 2.7-1.2 1.6 0 2.8 1.1 2.8 2.4 0 1-.8 1.7-1.3 2.1z"
            />
        </svg>
        <b v-show="hasSpecifications">!</b>
    </a>
</template>

<script lang="ts">
    import {Component, Vue, Prop} from 'vue-facing-decorator';
    import {OpenShift, OpenShiftApplication, OpenShiftApplicationState} from '@cquential/api';
    import RoosterplanningUrlBuilder from '@/util/RoosterplanningUrlBuilder';

    @Component
    export default class OpenShiftIcon extends Vue {
        @Prop({type: Number, required: true}) public rosterId!: number;
        @Prop({required: true}) public date!: Date;
        @Prop({required: true}) public openShift!: OpenShift;

        public get hasApplications(): boolean {
            return this.openShift?.hasExternalApplications
                || this.openShift.applications!.some((application: OpenShiftApplication): boolean => application.state === OpenShiftApplicationState.Applied);
        }

        public get hasSpecifications(): boolean {
            return this.openShift.specifications!.length > 0;
        }

        public get hasOtherCompanies(): boolean {
            return this.openShift.publishedToOtherCompanies!.length > 0;
        }

        public get link(): string {
            return `${RoosterplanningUrlBuilder.getHostUrl()}?pageid=P_ROSTER_OPENSHIFT&rosterid=${this.rosterId}&date=${(this.date.valueOf() / 1000).toFixed(0)}&openshiftid=${this.openShift.id}`;
        }
    }
</script>

<style lang="scss" scoped>
    a {
        display: inline-block;
        margin-left: 0.25rem;
        text-decoration: none;
        --open-shift-color: var(--open-shift-open);
        color: var(--open-shift-color);

        &.other-companies {
            --open-shift-color: var(--open-shift-other-companies);
        }

        &.applications {
            --open-shift-color: var(--open-shift-applications);
        }

        svg {
            vertical-align: bottom;
            width: 1rem;
            height: 1rem;

            path {
                fill: var(--open-shift-color);
            }
        }

        b {
            font-size: 1.2em;
            font-weight: 900;
        }
    }
</style>
